export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const FETCH_USER_ADDRESSES_REQUEST = 'FETCH_USER_ADDRESSES_REQUEST';
export const FETCH_USER_ADDRESSES_SUCCESS = 'FETCH_USER_ADDRESSES_SUCCESS';
export const FETCH_USER_ADDRESSES_FAILURE = 'FETCH_USER_ADDRESSES_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const ADD_USER_ADDRESS_REQUEST = 'ADD_USER_ADDRESS_REQUEST';
export const ADD_USER_ADDRESS_SUCCESS = 'ADD_USER_ADDRESS_SUCCESS';
export const ADD_USER_ADDRESS_FAILURE = 'ADD_USER_ADDRESS_FAILURE';

export const UPDATE_USER_ADDRESS_REQUEST = 'UPDATE_USER_ADDRESS_REQUEST';
export const UPDATE_USER_ADDRESS_SUCCESS = 'UPDATE_USER_ADDRESS_SUCCESS';
export const UPDATE_USER_ADDRESS_FAILURE = 'UPDATE_USER_ADDRESS_FAILURE';

export const UPDATE_USER_SECURITY_REQUEST = 'UPDATE_USER_SECURITY_REQUEST';
export const UPDATE_USER_SECURITY_SUCCESS = 'UPDATE_USER_SECURITY_SUCCESS';
export const UPDATE_USER_SECURITY_FAILURE = 'UPDATE_USER_SECURITY_FAILURE';

export const CHANGE_PHONENUMBER_REQUEST = 'CHANGE_PHONENUMBER_REQUEST';
export const CHANGE_PHONENUMBER_SUCCESS = 'CHANGE_PHONENUMBER_SUCCESS';
export const CHANGE_PHONENUMBER_FAILURE = 'CHANGE_PHONENUMBER_FAILURE';

export const FETCH_USER_ADDRESS_REQUEST = 'FETCH_USER_ADDRESS_REQUEST';
export const FETCH_USER_ADDRESS_SUCCESS = 'FETCH_USER_ADDRESS_SUCCESS';
export const FETCH_USER_ADDRESS_FAILURE = 'FETCH_USER_ADDRESS_FAILURE';

export const FETCH_USER_SERVICES_REQUEST = 'FETCH_USER_SERVICES_REQUEST';
export const FETCH_USER_SERVICES_SUCCESS = 'FETCH_USER_SERVICES_SUCCESS';
export const FETCH_USER_SERVICES_FAILURE = 'FETCH_USER_SERVICES_FAILURE';

export const ADD_USER_SERVICE_REQUEST = 'ADD_USER_SERVICE_REQUEST';
export const ADD_USER_SERVICE_SUCCESS = 'ADD_USER_SERVICE_SUCCESS';
export const ADD_USER_SERVICE_FAILURE = 'ADD_USER_SERVICE_FAILURE';

export const UPDATE_USER_SERVICE_REQUEST = 'UPDATE_USER_SERVICE_REQUEST';
export const UPDATE_USER_SERVICE_SUCCESS = 'UPDATE_USER_SERVICE_SUCCESS';
export const UPDATE_USER_SERVICE_FAILURE = 'UPDATE_USER_SERVICE_FAILURE';

export const ADD_SERVICES_BATCH_REQUEST = 'ADD_SERVICES_BATCH_REQUEST';
export const ADD_SERVICES_BATCH_SUCCESS = 'ADD_SERVICES_BATCH_SUCCESS';
export const ADD_SERVICES_BATCH_FAILURE = 'ADD_SERVICES_BATCH_FAILURE';

export const DELETE_USER_SERVICE_REQUEST = 'DELETE_USER_SERVICE_REQUEST';
export const DELETE_USER_SERVICE_SUCCESS = 'DELETE_USER_SERVICE_SUCCESS';
export const DELETE_USER_SERVICE_FAILURE = 'DELETE_USER_SERVICE_FAILURE';

export const FETCH_REPRESENTATIVES_REQUEST = 'FETCH_REPRESENTATIVES_REQUEST';
export const FETCH_REPRESENTATIVES_SUCCESS = 'FETCH_REPRESENTATIVES_SUCCESS';
export const FETCH_REPRESENTATIVES_FAILURE = 'FETCH_REPRESENTATIVES_FAILURE';

export const ADD_REPRESENTATIVE_REQUEST = 'ADD_REPRESENTATIVE_REQUEST';
export const ADD_REPRESENTATIVE_SUCCESS = 'ADD_REPRESENTATIVE_SUCCESS';
export const ADD_REPRESENTATIVE_FAILURE = 'ADD_REPRESENTATIVE_FAILURE';

export const UPDATE_REPRESENTATIVE_REQUEST = 'UPDATE_REPRESENTATIVE_REQUEST';
export const UPDATE_REPRESENTATIVE_SUCCESS = 'UPDATE_REPRESENTATIVE_SUCCESS';
export const UPDATE_REPRESENTATIVE_FAILURE = 'UPDATE_REPRESENTATIVE_FAILURE';

export const FETCH_REPRESENTATIVES_ADDRESS_REQUEST = 'FETCH_REPRESENTATIVES_ADDRESS_REQUEST';
export const FETCH_REPRESENTATIVES_ADDRESS_SUCCESS = 'FETCH_REPRESENTATIVES_ADDRESS_SUCCESS';
export const FETCH_REPRESENTATIVES_ADDRESS_FAILURE = 'FETCH_REPRESENTATIVES_ADDRESS_FAILURE';

export const ADD_REPRESENTATIVE_ADDRESS_REQUEST = 'ADD_REPRESENTATIVE_ADDRESS_REQUEST';
export const ADD_REPRESENTATIVE_ADDRESS_SUCCESS = 'ADD_REPRESENTATIVE_ADDRESS_SUCCESS';
export const ADD_REPRESENTATIVE_ADDRESS_FAILURE = 'ADD_REPRESENTATIVE_ADDRESS_FAILURE';

export const UPDATE_REPRESENTATIVE_ADDRESS_REQUEST = 'UPDATE_REPRESENTATIVE_ADDRESS_REQUEST';
export const UPDATE_REPRESENTATIVE_ADDRESS_SUCCESS = 'UPDATE_REPRESENTATIVE_ADDRESS_SUCCESS';
export const UPDATE_REPRESENTATIVE_ADDRESS_FAILURE = 'UPDATE_REPRESENTATIVE_ADDRESS_FAILURE';

export const DELETE_REPRESENTATIVE_REQUEST = 'DELETE_REPRESENTATIVE_REQUEST';
export const DELETE_REPRESENTATIVE_SUCCESS = 'DELETE_REPRESENTATIVE_SUCCESS';
export const DELETE_REPRESENTATIVE_FAILURE = 'DELETE_REPRESENTATIVE_FAILURE';

export const RESET_USER_STATE = 'RESET_USER_STATE';

export const UPLOAD_DOCUMENT_REQUEST = 'UPLOAD_DOCUMENT_REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAILURE = 'UPLOAD_DOCUMENT_FAILURE';

export const FETCH_DOCUMENTS_REQUEST = 'FETCH_DOCUMENTS_REQUEST';
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_FAILURE = 'FETCH_DOCUMENTS_FAILURE';

export const DOWNLOAD_DOCUMENT_REQUEST = 'DOWNLOAD_DOCUMENT_REQUEST';
export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';
export const DOWNLOAD_DOCUMENT_FAILURE = 'DOWNLOAD_DOCUMENT_FAILURE';

export const DELETE_DOCUMENT_REQUEST = 'DELETE_DOCUMENT_REQUEST';
export const DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS';
export const DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE';

export const EDIT_DOCUMENT_REQUEST = 'EDIT_DOCUMENT_REQUEST';
export const EDIT_DOCUMENT_SUCCESS = 'EDIT_DOCUMENT_SUCCESS';
export const EDIT_DOCUMENT_FAILURE = 'EDIT_DOCUMENT_FAILURE';

export const UPDATE_MESSAGE_REQUEST = 'UPDATE_MESSAGE_REQUEST';
export const UPDATE_MESSAGE_SUCCESS = 'UPDATE_MESSAGE_SUCCESS';
export const UPDATE_MESSAGE_FAILURE = 'UPDATE_MESSAGE_FAILURE';

export const FETCH_MESSAGE_REQUEST = 'FETCH_MESSAGE_REQUEST';
export const FETCH_MESSAGE_SUCCESS = 'FETCH_MESSAGE_SUCCESS';
export const FETCH_MESSAGE_FAILURE = 'FETCH_MESSAGE_FAILURE';

export const GET_PROFILEPIC_REQUEST = 'GET_PROFILEPIC_REQUEST';
export const GET_PROFILEPIC_SUCCESS = 'GET_PROFILEPIC_SUCCESS';
export const GET_PROFILEPIC_FAILURE = 'GET_PROFILEPIC_FAILURE';

export const DELETE_PROFILEPIC_REQUEST = 'DELETE_PROFILEPIC_REQUEST';
export const DELETE_PROFILEPIC_SUCCESS = 'DELETE_PROFILEPIC_SUCCESS';
export const DELETE_PROFILEPIC_FAILURE = 'DELETE_PROFILEPIC_FAILURE';

export const UPLOAD_PROFILEPIC_REQUEST = 'UPLOAD_PROFILEPIC_REQUEST';
export const UPLOAD_PROFILEPIC_SUCCESS = 'UPLOAD_PROFILEPIC_SUCCESS';
export const UPLOAD_PROFILEPIC_FAILURE = 'UPLOAD_PROFILEPIC_FAILURE';

export const SEARCH_SERVICE_REQUEST = 'SEARCH_SERVICE_REQUEST';
export const SEARCH_SERVICE_SUCCESS = 'SEARCH_SERVICE_SUCCESS';
export const SEARCH_SERVICE_FAILURE = 'SEARCH_SERVICE_FAILURE';

export const UPDATE_ONBOARDINGSTEP_REQUEST = 'UPDATE_ONBOARDINGSTEP_REQUEST';
export const UPDATE_ONBOARDINGSTEP_SUCCESS = 'UPDATE_ONBOARDINGSTEP_SUCCESS';
export const UPDATE_ONBOARDINGSTEP_FAILURE = 'UPDATE_ONBOARDINGSTEP_FAILURE';

export const SET_COMPLETE_REQUEST = 'SET_COMPLETE_REQUEST';
export const SET_COMPLETE_SUCCESS = 'SET_COMPLETE_SUCCESS';
export const SET_COMPLETE_FAILURE = 'SET_COMPLETE_FAILURE';

export const ADD_PAYMENTMETHOD_REQUEST = 'ADD_PAYMENTMETHOD_REQUEST';
export const ADD_PAYMENTMETHOD_SUCCESS = 'ADD_PAYMENTMETHOD_SUCCESS';
export const ADD_PAYMENTMETHOD_FAILURE = 'ADD_PAYMENTMETHOD_FAILURE';

export const REMOVE_PAYMENTMETHOD_REQUEST = 'REMOVE_PAYMENTMETHOD_REQUEST';
export const REMOVE_PAYMENTMETHOD_SUCCESS = 'REMOVE_PAYMENTMETHOD_SUCCESS';
export const REMOVE_PAYMENTMETHOD_FAILURE = 'REMOVE_PAYMENTMETHOD_FAILURE';

export const PROCESS_PAYMENT_REQUEST = 'PROCESS_PAYMENT_REQUEST';
export const PROCESS_PAYMENT_SUCCESS = 'PROCESS_PAYMENT_SUCCESS';
export const PROCESS_PAYMENT_FAILURE = 'PROCESS_PAYMENT_FAILURE';

export const GET_SETUPINTENT_REQUEST = 'GET_SETUPINTENT_REQUEST';
export const GET_SETUPINTENT_SUCCESS = 'GET_SETUPINTENT_SUCCESS';
export const GET_SETUPINTENT_FAILURE = 'GET_SETUPINTENT_FAILURE';

export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';

export const FETCH_USERREPRESENTING_REQUEST = 'FETCH_USERREPRESENTING_REQUEST';
export const FETCH_USERREPRESENTING_SUCCESS = 'FETCH_USERREPRESENTING_SUCCESS';
export const FETCH_USERREPRESENTING_FAILURE = 'FETCH_USERREPRESENTING_FAILURE';

export const AUTHENTICATE_FACILITA_REQUEST = 'AUTHENTICATE_FACILITA_REQUEST';
export const AUTHENTICATE_FACILITA_SUCCESS = 'AUTHENTICATE_FACILITA_SUCCESS';
export const AUTHENTICATE_FACILITA_FAILURE = 'AUTHENTICATE_FACILITA_FAILURE';

export const GET_BILLINGCUSTOMERID_REQUEST = 'GET_BILLINGCUSTOMERID_REQUEST';
export const GET_BILLINGCUSTOMERID_SUCCESS = 'GET_BILLINGCUSTOMERID_SUCCESS';
export const GET_BILLINGCUSTOMERID_FAILURE = 'GET_BILLINGCUSTOMERID_FAILURE';